import { Button as MuiButton, ButtonProps } from "@mui/material";
import { PropsWithChildren } from "react";

type IProps = ButtonProps & {

}

const Button: React.FC<PropsWithChildren<IProps>> = (props) => {
    const { children, ...rest } = props;

    return <>
        <MuiButton {...rest}>
            {children}
        </MuiButton>
    </>
}

export default Button;